import uiRouter from 'angular-ui-router';
import {smallbookingDirective} from './smallbooking.directive';
import {smallbookingStore} from './smallbooking.store';

export const smallbooking = angular.module('smallbooking', [uiRouter])
  .config(($stateProvider) => {
    $stateProvider.state('app.smallbooking', {
      template: '<smallbooking></smallbooking>'
    });
  })
  .directive('smallbooking', smallbookingDirective)
  .factory('smallbookingStore', smallbookingStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/smallbooking/smallbooking.js
 **/